import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

export const TableCellTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    fontSize: theme.typography.body2.fontSize,
  },
}));

export const TableCellSelect = styled(Select)(({ theme }) => ({
  width: "100%",
  fontSize: theme.typography.body2.fontSize,
}));
